import { Box as MuiBox, BoxProps as MuiBoxProps, styled } from "@mui/material";

const StyledBox = styled(MuiBox)(() => ({
  // Add custom styles here if needed
}));

interface BoxProps extends MuiBoxProps {
  children: React.ReactNode;
}

export const Box: React.FC<BoxProps> = ({ children, ...props }) => {
  return <StyledBox {...props}>{children}</StyledBox>;
};

export default Box;
